import React from "react";

export interface RadioItem {
    name: string,
    id: any
}

export interface IProps {
    title: string,
    data: Array<RadioItem>,
    id: any,
    errMsg?: string,
    onClick: (id: any) => void
}

function RadioForm(props: IProps) {
    const {title, data, id, errMsg, onClick} = props

    const $radio = (checked: boolean, radioItem: RadioItem, idx: number) => {
        return (
            <label key={idx} className={"cursor-pointer flex flex-row items-center hover:bg-theme-blue-10 p-2 rounded space-x-2"}>
                <input onClick={() => {
                    onClick && onClick(radioItem.id)
                }} onChange={() => {
                    //
                }} checked={checked} type={"radio"} className="cursor-pointer f form-radio h-5 w-5 text-primary active:ring-1 active:theme-blue focus:ring-1 focus:theme-blue" />
                <p className={`text-sm ${checked ? "text-theme-blue" : "text-gray-2"} font-medium`}>{radioItem.name}</p>
            </label>
        )
    }

    const $errMsg = errMsg?.length ? (<p className={"text-sm text-red-300"}>{errMsg}</p>) : null
    return (
        <div className={"w-full"}>
            <p className={"relative font-medium text-gray-1 text-sm text-left"}>{title}</p>
            <div className={"mt-2 flex flex-col lg:flex-row space-y-1 lg:space-y-0 lg:space-x-4"}>
                {data.map((item, idx) => {
                    return ($radio(id === item.id, item, idx))
                })}
            </div>
            {$errMsg}
        </div>
    )
}

export default RadioForm
